import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';
import { ResponcePage } from 'projects/core/src/lib/misc/data/responce-page';
import { Material } from './material';
import { MaterialPage } from './materials-page';

@JsonObject('MaterialsResponcePage')
export class MaterialsResponcePage extends ResponcePage {

    @JsonProperty([MaterialPage], 'content')
    content: MaterialPage[];
}